import { INTERNATIONAL_SPONSOR } from "../../../../../common/constants/sponsor-constants";
import { BasicSponsor } from "../../Sponsorship/Sponsorship";
import SponsorDetail from "../SponsorDetail";

type Props = {
  internationalSponsor: BasicSponsor;
};

const LeafInternationalSponsor = (props: Props) => {
  const { internationalSponsor } = props;
  const show = internationalSponsor.isValid === true; // Future will have an additional configuration (disableInternational) will be added here

  return <SponsorDetail sponsor={internationalSponsor} show={show} sponsorType={INTERNATIONAL_SPONSOR} />;
};

export default LeafInternationalSponsor;
